export const getDefaultMutations = {
  updateAuthentication:(state) => {
    state.isAuthenticated = true;
  },
  logout:(state) => {
    state.isAuthenticated = false;
  },
  updateIngredient: (state,payload) => {
    Object.assign(state.ingredients[payload.inIndex], payload.ingredient)
  },
  setIngredient: (state,payload) => {
    state.ingredients.push(payload);
  },
  deleteIngredient: (state,payload) => {
    state.ingredients.splice(payload, 1);
  },
  changePostsLoading: (state,payload) => {
    state.postsLoading = payload;
  },
  changeIngredientsLoading: (state,payload) => {
    state.ingredientsLoading = payload;
  },
  fetchIngredients: (state,payload) => {
    state.ingredients = payload.data;
  },
  fetchPosts: (state,payload) => {
    state.totalPosts = payload.length;
    state.posts = payload;
    state.postsLoading = false;
  },
  resetLoadingStatus:(state) => {
    state.postsLoading = true;
  },
  fetchCategories: (state,payload) => {
    let selectItems = []
    payload.forEach((item) => {
      let newSelectItem = {
        text: item.name, value: ''+item.id+'', selected: false
      }
      selectItems.push(newSelectItem);
    });

    state.postsCategories = selectItems;
  },
  fetchPostToEdit: (state,payload) => {
    state.postToEdit = payload;
    state.loadingPostToEdit = false;
  },
  setPostToEdit:(state,payload) => {

    const parseUniCode = (parseString) => {
      return parseString.replace(/\\x([0-9a-f]{1,4})/gi, function(m, c0) {
        return "\\u" + ("0000" + c0).slice(-4);
      }).replace(/(<([^>]+)>)/ig, '');
    }

    let splitted = payload.publishing_date_from.split(' ');
    payload.publishing_date_from_date = splitted[0];
    payload.publishing_date_from_time = splitted[1];
    payload.extraTitle  = (payload.recipe_title!== '') ?  true : false;
    if(payload.tags === null){
      payload.tags = '';
    }
    if(typeof payload.content_container == 'string'){
      if(payload.content_container !== '' && payload.content_container !== null){
        payload.content_container = JSON.parse(payload.content_container);
        payload.content_container.forEach((item,index) => {
          if(item.content_type == '6'){
            payload.content_container[index].content_element_text = parseUniCode(item.content_element_text)
            item.content_element_text = parseUniCode(item.content_element_text)
          }
        });
      }else{
        payload.content_container = [];
      }
      if(payload.recipe_container !== ''&& payload.recipe_container !== null){
        payload.recipe_container = JSON.parse(parseUniCode(payload.recipe_container));
      }else{
        payload.recipe_container = [];
      }
      /*if(payload.opener_text !== ''){
        payload.opener_text = payload.opener_text;
      }*/
      if(payload.opener_media_type === 'images'){
        payload.opener_images = JSON.parse(parseUniCode(payload.opener_images));
        payload.opener_images.forEach(item => {
          item.modified = false;
          if(item.name.slice(0,-4) === payload.previewImageName && item.preview === undefined){
            item.preview = true;
          }else if(item.preview === undefined){
            item.preview = false;
          }
        })
      }
    }
    state.postToEdit = payload;
  },
  checkAllowedTime:(state,payload) =>{
    let d = new Date();
    let nowMillis = Date.parse(d);
    let millisOfThirty = 30*60*1000;
    let itemDateMillis = new Date(payload).getTime();
    let thirtyBefore = itemDateMillis - millisOfThirty;
    let thirtyAfter = itemDateMillis + millisOfThirty;
    if(nowMillis < thirtyBefore || nowMillis > thirtyAfter){
      state.allowedToEdit = true;
    }
  },
  togglePostIsSaved (state) {
    state.postIsSaved = !state.postIsSaved
  },
  activateDialog:(state,payload)=>{
    Object.assign(state.dialog, payload)
  },
  deactivateDialog: (state) => {
    Object.assign(state.dialog, state.dialogDefault)
  },
  updateCharts:(state,payload) => {
    state.charts.viewsLastThirtyDays = payload[0];
    state.charts.viewsLastSevenDays = payload[1];
    state.charts.allTags = payload[2];
  },
  dontDoanything:() => {
    console.log('nothing');
  }
}

